import { bubblingNode } from '@/components/common/controlBar/controlBarDialog/metaComponent/worker.js'

export function isBelongCombinedNode(node) {
  var arr = [
    'image_text_tab_1',
    'image_text_tab_2',
    'image_text_tab_3',
    'image_text_tab_4',
    'banner1',
    'banner2',
    'bannerIcon',
    'product_intro_1',
    'product_intro_2',
    'product_intro_3',
    'product_tabNew_style1',
    'product_imgTextNew_style1',
    'product_tabNew_style1',
    'list_product_style1',
    'list_product_style2',
    'list_product_style3',
    'list_product_style4',
    'list_product_style5',
    'list_product_style6',
    'list_product_style7',
    'list_product_style8',
    'list_product_style9',
    'list_product_style11',
    'list_product_style12',
    'list_product_style13',
    'list_product_style14',
    'list_download_style1',
    'list_download_style2',
    'list_download_style3',
    'list_download_style4',
    'list_case_style1',
    'list_case_style2',
    'list_case_style3',
    'list_case_style4',
    'list_case_style5',
    'list_case_style6',
    'list_case_style7',
    'list_news_index_style1',
    'list_news_index_style3',
    'list_news_index_style4',
    'list_news_index_style5',
    'list_news_index_style6',
    'list_news_index_style7',
    'attrFilter_style_1',
    'cta_style_1',
    'banner_inside1',
    'map',
    'related_carousel_product1',
    'related_carousel_product2',
    'related_carousel_product3',
    'related_carousel_product4',
    'related_carousel_product5',
    'related_carousel_product6',
    'related_carousel_news1',
    'related_carousel_news2',
    'related_carousel_news3',
    'related_carousel_news4',
    'related_carousel_news5',
    'related_carousel_news6',
    'related_carousel_faq1',
    'related_carousel_faq2',
    'related_carousel_faq3',
    'related_carousel_faq4',
    'related_carousel_case1',
    'related_carousel_case2',
    'related_carousel_case3',
    'related_carousel_case4',
    'related_carousel_case5',
    'related_carousel_case6',
    'index_case1',
    'index_case2',
    'index_case3',
    'index_case4',
    'index_case5',
    'index_case6',
    'list_cert1',
    'list_cert2',
    'list_cert3',
    'list_cert4',
    'list_cert5',
    'list_news1',
    'list_news2',
    'list_news3',
    'list_news4',
    'list_news5',
    'list_news6',
    'list_news7',
    'search1',
    'search2',
    'search4',
    'list_faq_page',
    'expandCollapse_text_style1',
    'expandCollapse_text_style2',
    'expandCollapse_tags_style2',
    'expandCollapse_tags_style5',
    'product_imgText',
    'top_mobile',
    'home_product_one',
    'home_product_two',
    'home_product_three',
    'home_product_four',
    'home_product_five',
    'home_video_one',
    'home_video_two',
    'home_video_three',
    'video_list_one',
    'video_list_two',
    'list_cert_two',
    'list_cert_one',
    'head_style_one',
    'head_style_two',
    'head_style_three',
    'head_style_four',
    'head_style_five',
    'head_style_six',
    'news_detail_one',
    'news_detail_two',
    'news_detail_three',
    'news_detail_four',
    'case_detail_one',
    'case_detail_two',
    'case_detail_three',
    'case_detail_four',
    'list_download_widget',
    'product_cate_list',
    'product_cate_intro',
    'news_detail_three',
    'list_faq_carousel',
    'list_faq_carousel_list',
    'news_tab_two',
    'news_tab',
    'list_faq_carousel',
    'product_tab_three',
    'product_tab_four',
    'product_tab_five',
    'product_tab_six',
    'product_tab_two',
    'product_tab_seven',
    'product_imgText_style1',
    'product_imgText_style2',
    'product_imgText_style3',
    'product_classification_style1',
    'case_detail_four',
    'sideNavigation',
    'list_download_one',
    'list_download_two',
    'list_download_three',
    'list_download_four',
    'product_cate_list_one',
    'product_cate_list_two',
    'product_cate_list_three',
    'product_cate_list_four',
    'product_cate_list_five',
    'product_cate_list_six',
    'product_cate_list_seven',
    'product_cate_intro_one',
    'product_cate_intro_two',
    'product_cate_intro_three',
    'product_tab_1',
    'product_tab_2',
    'product_tab_3',
    'product_tab_4',
    'product_tab_5',
    'product_tab_6',
    'product_tab_7',
    'product_tab_8',
    'news_tab_1',
    'news_tab_2',
    'news_tab_3',
    'news_tab_4',
    'product_home_list_style2',
    'product_home_list_style4',
    'product_home_list_style5',
    'home_list_download_five',
    'related_carousel_product9',
    'product_home_list_style1',
    'product_home_list_style3',
    'product_home_list_style6',
    'product_home_list_style7',
    'related_carousel_product8',
    'related_carousel_product7',
    'product_category_style3',
    'product_category_style2',
    'product_category_style1',
    'product_category_style4',
    'product_category_style6',
    'product_category_style5',
    'product_category_style7',
    'head_style_seven',
    'head_style_eight',
    'head_style_nine',
    'head_style_ten',
    'head_style_eleven',
    'head_style_twelve',
    'head_style_thirteen',
    'head_style_fourteen',
    'head_style_fifteen',
    'product_detail_1',
    'product_detail_2',
    'product_detail_3',
    'product_detail_4',
    'foot_module1',
    'foot_module2',
    'foot_module3',
    'foot_module4',
    'foot_module5',
    'divider2',
    'related_carousel_new_news_style1',
    'related_carousel_new_news_style2',
    'related_carousel_new_news_style3',
    'related_carousel_new_news_style4',
    'related_carousel_new_case_style3',
    'related_carousel_new_case_style4',
    'divider2',
    'list_news_style1',
    'list_news_style8',
    'index_case_style1',
    'index_case_style2',
    'index_case_style3',
    'advantage_process_style1',
    'slider_images',
    'fixed_point_style1',
    'scroll_text_style1',
    'home_product_list_style1',
    'home_product_list_style2',
    'home_image_text_list_style1',
    'development_history_style3',
    'accordion_style1',
    'three_five_slider',
    'development_history_style4',
    'head_mobile_style1',
    'head_mobile_style2',
    'development_history_2',
    'index_case_10',
    'development_history_style1',
    'high_components_style1',
    'product_tabNew_style2'
  ]
  var res = arr.includes(node._type)
  return res
}

export function getClosestNodeByCondition(node, conditionFn) {
  var res = undefined
  walkNodeUp(node, (walkedNode) => {
    if (conditionFn(walkedNode)) {
      if (!res) {
        res = walkedNode
      }
    }
  })
  return res
}

export function getAncestorCombinedNode(node) {
  var res = getClosestNodeByCondition(node, (walkedNode) => {
    return isBelongCombinedNode(walkedNode)
  })
  return res
}

//遍历节点
export function walkNodeUp(node, fn) {
  fn(node)
  bubblingNode(node, (bubblingNode) => {
    fn(bubblingNode)
  })
}
